import { createRouter } from '@tanstack/react-router';

import { routeTree } from '@/routeTree.gen';
import { queryClient } from '@/setup/queryClient';

export const router = createRouter({
  routeTree,
  scrollRestoration: true,
  context: {
    queryClient,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    user: undefined!,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ability: undefined!,
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
